import {
  addInEvidenceTemplateOptions,
  addLinkMoreOptions,
} from 'design-comuni-plone-theme/config/Blocks/ListingOptions';
import {
  removeTemplateOptions,
  changeDefaultValuesTemplateOptions,
} from './utils';

export const changeInEvidenceTemplateOptions = (blocksConfig) => {
  blocksConfig.blocksConfig.listing.variations.filter(
    (v) => v.id === 'inEvidenceTemplate',
  )[0].schemaEnhancer = ({ schema, formData, intl }) => {
    addInEvidenceTemplateOptions(schema, formData, intl); // aggiungo i campi di default di io-comune e poi tolgo quelli che mi interessano
    removeTemplateOptions(
      [
        //rimuovo questi campi e li metto di default a false.
        'show_topics',
      ],
      schema,
    );
    addLinkMoreOptions(schema, formData, intl);
    return schema;
  };
};
